import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../utils/auth';
import { useChatContext } from '../context/useChatContext.js';

function AdminRoute({ children }) {
  const { isAdmin, isSuperAdmin } = useChatContext();

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  // Aguardar a definição do papel na inicialização
  if (isSuperAdmin === null) {
    return (
      <div className="app-boot-loading">
        <div className="app-boot-loading__content">Carregando perfil...</div>
      </div>
    );
  }

  if (isAdmin || isSuperAdmin) {
    return children;
  }

  return <Navigate to="/dashboard" replace />;
}

export default AdminRoute;
